import React, { useEffect, useRef } from 'react';
import { Spinner } from 'reactstrap';
import PropTypes from 'prop-types';

const SpinnerModal = ({ background }) => {
  const dialogRef = useRef(null);

  // focus moves onto the overlay while it is up and back to where it was afterwards
  useEffect(() => {
    const previousFocus = document.activeElement;
    dialogRef.current && dialogRef.current.focus();

    return () => {
      previousFocus && document.contains(previousFocus) && previousFocus.focus();
    };
  }, []);

  return (
    <div style={{ position: 'relative', zIndex: 1050 }} className="d-block">
      <div
        ref={dialogRef}
        className={'modal fade show d-block ' + background}
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-label="Loading"
      >
        <div className="modal-dialog content-container m-auto h-100">
          <div className="content d-flex h-100">
            <Spinner className="avatar-3xl m-auto" />
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </div>
  );
};

SpinnerModal.propTypes = {
  background: PropTypes.string
};

SpinnerModal.defaultProps = {
  background: 'bg-100'
};

export default SpinnerModal;
